'use client'

import { formatCurrencyWhole } from '@repo/utils/numbers'
import { useEffect, useState } from 'react'
import { useTimeRecordingStore } from '@repo/store/useTimeRecordingStore'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const TimeRecordingDailySummary = ({ entries, groupedDate }) => {
  const [totalMinutes, setTotalMinutes] = useState(0)
  const [totalUnits, setTotalUnits] = useState(0)
  const [totalValue, setTotalValue] = useState(0)
  const { formatTime } = useTimeRecordingStore()

  useEffect(() => {
    if (!groupedDate) return

    if (Array.isArray(entries)) {
      const totalEntryMinutes = entries.reduce((sum, entry) => sum + (entry.timeMinutes || 0), 0)
      const totalEntryUnits = entries.reduce((sum, entry) => sum + (entry.timeUnits || 0), 0)
      const totalEntryValue = entries.reduce((sum, entry) => sum + (entry.value || 0), 0)

      setTotalMinutes(totalEntryMinutes)
      setTotalUnits(totalEntryUnits)
      setTotalValue(totalEntryValue)
    }
  }, [entries, groupedDate])

  return (
    <MUIStack
      gap={4}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      data-testid="TimeRecordingDailySummary"
      sx={{
        padding: '1rem',
        backgroundColor: 'rgba(61, 81, 123, 0.1)',
        borderRadius: '4px',
        transition: 'all 250ms'
      }}
    >
      <MUIStack
        gap={4}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <MUIStack
          gap={0}
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="center"
          width="100%"
        >
          <MUITypography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 0, textTransform: 'uppercase', color: 'text.primary' }}
          >
            Units
          </MUITypography>
          <MUITypography variant="body1" color="text.secondary" sx={{ mb: 0 }}>
            {totalUnits} Units
          </MUITypography>
        </MUIStack>
        <MUIStack
          gap={0}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <MUITypography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 0, textTransform: 'uppercase', color: 'text.primary' }}
          >
            Time
          </MUITypography>
          <MUITypography variant="body1" color="text.secondary" sx={{ mb: 0 }}>
            {formatTime(totalMinutes * 60)}
          </MUITypography>
        </MUIStack>
        <MUIStack
          gap={0}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <MUITypography
            variant="h6"
            color="text.secondary"
            sx={{ mb: 0, textTransform: 'uppercase', color: 'text.primary' }}
          >
            Value
          </MUITypography>
          <MUITypography variant="body1" color="text.secondary" sx={{ mb: 0 }}>
            {formatCurrencyWhole(totalValue, true)}
          </MUITypography>
        </MUIStack>
      </MUIStack>
    </MUIStack>
  )
}

TimeRecordingDailySummary.propTypes = {
  entries: PropTypes.array,
  groupedDate: PropTypes.string
}
